import api from '@/api/apiTmaps/apiConsumption';

export default {
  async get({ commit, dispatch }) {
    try {
      let consumption;
      const consumptionResponse = await api.get();
      if (consumptionResponse.status === 200) {
        consumption = consumptionResponse.data;
      }
      if (consumption) {
        commit('set', consumption);
      }
    } catch (e) {
      dispatch('errorHandler/throwDefaultError', e, { root: true });
    }
  },
};
